import React from "react";
import { Link, useLocation } from "react-router-dom";
import '../../assets/css/layout/student/Sidebar.css';
import { useNavigate } from "react-router-dom";

import { 
  LayoutDashboard, 
  User, 
  FileText, 
  History, 
  LogOut,
  GraduationCap
} from "lucide-react";


const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { path: "/student/dashboard", icon: LayoutDashboard, label: "Dashboard" },
    { path: "/student/myrequests", icon: FileText, label: "My Requests" },
    { path: "/student/ticketsystem", icon: FileText, label: "Help&Support" },
    // { path: "/student/Disputes", icon: FileText, label: "Disputes" },
    { path: "/student/history", icon: History, label: "Donation History" },
    { path: "/student/profile", icon: User, label: "Profile" },
  ];

  const isActive = (path) => location.pathname === path;

 
  const handleLogout = () => {
    localStorage.removeItem('student'); 
    navigate('/student/login');       
  };

  return (
    <aside className="ssb-sidebar">
      {/* Logo */}
      <div className="ssb-sidebar-logo">
        <div
          className="ssb-logo-icon"
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/")}
        >
          <GraduationCap size={24} />
        </div>
        <span>Student Support Hub</span>
      </div>

      {/* Navigation Menu */}
      <nav className="ssb-sidebar-menu">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);

          return (
            <Link
              key={item.path}
              to={item.path}
              className={`ssb-sidebar-link ${active ? 'ssb-active' : ''}`}
            >
              <Icon size={20} />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </nav>

   <div className="ssb-sidebar-logout">
  <button className="ssb-logout-btn" onClick={() => {
    localStorage.removeItem('studentEmail');
    localStorage.removeItem('studentPassword');
    navigate('/student/login');
  }}>
    <LogOut size={20} />
    <span>Logout</span>
  </button>
</div>
    </aside>
  );
};

export default Sidebar;